import React from "react";

function GuardHealthSafety() {
    return (
        <div>
            <h2>Health & Safety in the Workplace</h2>
            <p>
                Security guards play a vital role in promoting and maintaining health and safety on site. This module covers hazard awareness, risk assessments, and your legal responsibilities under UK health and safety law.
            </p>

            <h3>Legal Framework</h3>
            <ul>
                <li><strong>Health and Safety at Work Act 1974</strong> – Primary legislation for workplace safety</li>
                <li><strong>Management of Health and Safety at Work Regulations 1999</strong> – Requires risk assessments and safety procedures</li>
                <li><strong>Reporting of Injuries, Diseases and Dangerous Occurrences Regulations (RIDDOR)</strong> – Governs incident reporting</li>
            </ul>

            <h3>Common Workplace Hazards</h3>
            <ul>
                <li>Slips, trips, and falls</li>
                <li>Manual handling injuries</li>
                <li>Electrical hazards</li>
                <li>Fire risks</li>
                <li>Violence or aggression from the public</li>
            </ul>

            <h3>Risk Assessments</h3>
            <ul>
                <li>Identify potential hazards</li>
                <li>Assess who might be harmed and how</li>
                <li>Evaluate the risk and implement control measures</li>
                <li>Record findings and review regularly</li>
            </ul>

            <h3>Your Responsibilities</h3>
            <ul>
                <li>Follow site safety procedures and training</li>
                <li>Report hazards or unsafe conditions immediately</li>
                <li>Use personal protective equipment (PPE) when required</li>
                <li>Do not take unnecessary risks</li>
                <li>Assist in evacuations and emergency responses</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> You notice a leaking pipe near an electrical cabinet. What steps do you take to ensure safety and report the issue?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.hse.gov.uk/" target="_blank" rel="noreferrer">HSE – Health and Safety Executive</a></li>
                <li><a href="https://www.hse.gov.uk/toolbox/" target="_blank" rel="noreferrer">HSE Toolbox – Practical Guidance</a></li>
                <li><a href="https://www.gov.uk/report-accident-at-work" target="_blank" rel="noreferrer">UK Gov – Reporting Accidents at Work</a></li>
            </ul>
        </div>
    );
}

export default GuardHealthSafety;
